import {gql} from "apollo-boost";

export const GET_STUDENTENROLLDETAIL_BYID = gql`
  query getStudentEnrollDetail($id: ID!) {
    getStudentEnrollDetail(
      id: $id
    ) {
      id sectionNo subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      student {
        id code
      }
      studentEnroll {
        id periodCode
      }
      studentUnitLearns {
        id unitSeq totalVdoLength totalLearnTime learnPercent
      }
      subject {
        id code nameLocal description creditCalGrade
      }
      courseOutlineRegistration {
        id
        courseOutline {
          id instruction
          courseOutlineUnits {
            id seq nameLocal nameEng descriptionLocal descriptionEng
            preTestExpectScore postTestExpectScore unitAgenda unitObjective unitReference
            countLearnPercent
          }
          courseOutlineAssessments {
            id seq percent score
            assessment {
              id nameLocal
            }
          }
        }
        teacher {
          id code firstNameLocal lastNameLocal telephone email availableTime socialMedia picturePath
          prefix {
            nameLocal
          }
        }
      }
      classSection {
        id learnSpanNo sectionNo
        vdoSet {
          id totalVdoLength
          vdoSetUnits {
            id totalVdoLength status
            courseOutlineUnit {
              id
            }
          }
        }
        classMaterials {
          id sequence nameLocal uploadPath uploadPathUri uploadFileName
        }
        classAssignments {
          id sequence topicLocal score dueDate uploadPathUri active
        }
      }
      studentUnitTests {
        id
        pretestMaxScore pretestQuestionQty pretestScore isPretestDone
        posttestMaxScore posttestQuestionQty posttestScore isPosttestDone
        courseOutlineUnit {
          id
        }
      }
      studentUnitLearns {
        id unitSeq totalVdoLength totalLearnTime learnPercent
        vdoSetUnit {
          id
        }
        courseOutlineUnit {
          id countLearnPercent
        }
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAIL_BYID_FOR_LEARNING = gql`
  query getStudentEnrollDetail($id: ID!) {
    getStudentEnrollDetail(
      id: $id
    ) {
      id sectionNo subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      student {
        id code
      }
      studentEnroll {
        id periodCode
        academicPeriod {
          id
        }
      }
      subject {
        id code nameLocal description creditCalGrade
      }
      courseOutlineRegistration {
        id
        courseOutline {
          id instruction picturePath
          courseOutlineUnits {
            id seq nameLocal nameEng descriptionLocal descriptionEng
            preTestExpectScore postTestExpectScore unitAgenda unitObjective unitReference
            countLearnPercent
          }
        }
        academicPeriod{
          id
        }
        teacher {
          id code firstNameLocal lastNameLocal telephone email availableTime socialMedia picturePath
          prefix {
            nameLocal
          }
        }
      }
      classSection {
        id learnSpanNo sectionNo
        vdoSet {
          id totalVdoLength
          vdoSetUnits {
            id totalVdoLength status
            courseOutlineUnit {
              id countLearnPercent
            }
            vdoSetTopics {
              id no nameLocal nameEng vdoLength vdoStreamPath isEnabled
            }
          }
        }
      }
      studentUnitTests {
        id
        pretestMaxScore pretestQuestionQty pretestScore isPretestDone
        posttestMaxScore posttestQuestionQty posttestScore isPosttestDone
        courseOutlineUnit { id }
      }
      studentUnitLearns {
        id unitSeq totalVdoLength totalLearnTime learnPercent
        vdoSetUnit { id }
        courseOutlineUnit { id countLearnPercent }
        studentTopicLearns {
          id learnTime learnPercent vdoLength
          firstPlayVdo startPlayVdo stopPlayVdo
          vdoSetTopic { id }
        }
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAIL_LIST = gql`
  query getStudentEnrollDetails {
    getStudentEnrollDetails {
      id
      studentEnroll
      enrollNo
      studentCode
      courseOutlineRegistration {
        subject {
          id
        }
      }
    }
  }
`;

export const GET_STUDENTENROLLDETAIL_LIST_BYSTUDENTENROLLID = gql`
  query getStudentEnrollDetailsByStudentEnrollId(
    $id: ID!
  ) {
    getStudentEnrollDetailsByStudentEnrollId(
      id: $id
    ) {
      id
      studentEnroll {
        id
      }
      enrollNo
      studentCode
      classSection {
        id
      }
      sectionNo
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id
        firstNameLocal
        lastNameLocal
      }
      teacherCode
      credit
      learnSpanNo
      examSpanNo
      isDrop
    }
  }
`;

export const GET_STUDENTENROLLDETAIL_LIST_BYFILTER = gql`
  query getStudentEnrollDetailsByFilter(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsByFilter(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id
    }
  }
`;

export const GET_STUDENT_IN_CLASS_SECTION_BY_CODE_OR_NAME = gql`
  query getStudentsInClassSectionByCodeOrName(
    $classSectionId: ID!
    $codeOrName: String!
    $limit: Int
  ) {
    getStudentsInClassSectionByCodeOrName(
      classSectionId: $classSectionId
      codeOrName: $codeOrName
      limit: $limit
    ) {
      id studentCode
      classSection { id sectionNo }
      courseOutlineRegistration {
        id subjectCode
        academicPeriod { id }
      }
      student {
        id code firstNameLocal lastNameLocal
        user { id code }
      }

    }
  }
`;

export const GET_TEACHERS_IN_STUDENT_ENROLL_BY_CODE_OR_NAME_CURRENT_USER = gql`
  query getTeachersInStudentEnrollByCodeOrNameCurrentUser(
    $academicPeriodId: ID!
  ) {
    getTeachersInStudentEnrollByCodeOrNameCurrentUser(
      academicPeriodId: $academicPeriodId
    ) {
      id teacherCode
      classSection { id sectionNo }
      courseOutlineRegistration {
        id subjectCode
        academicPeriod { id }
      }
      teacher {
        id code firstNameLocal lastNameLocal
        user { id code }
      }
      subjectCode

    }
  }
`;

export const GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER = gql`
  query getStudentEnrollDetailsByCurrentUser{
    getStudentEnrollDetailsByCurrentUser {
      id sectionNo subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id periodCode studentCode enrollDate totalCredit totalDropCredit
      }
      studentUnitLearns {
        id unitSeq totalVdoLength totalLearnTime learnPercent
        courseOutlineUnit { id countLearnPercent }
        vdoSetUnit { id }
      }
      courseOutlineRegistration{
        id
        courseOutline {
          id picturePath
        }
        teacher {
          id
          prefix {
            nameLocal
          }
          firstNameLocal
          lastNameLocal
          telephone
          email
          availableTime
          code
          picturePath
        }
      }
      subject {
        id
        code
        nameLocal
      }
      classSection {
        id sectionNo learnSpanNo
        vdoSet {
          id totalVdoLength
          vdoSetUnits {
            id totalVdoLength status
            courseOutlineUnit { id countLearnPercent }
          }
        }
      }
    }
  }
`;

export const GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER_WHILE_EXAM = gql`
  query getStudentEnrollDetailsByCurrentUser{
    getStudentEnrollDetailsByCurrentUser {
      id sectionNo subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id periodCode studentCode enrollDate totalCredit totalDropCredit
      }
      courseOutlineRegistration{
        id
        courseOutline {
          id picturePath
        }
        teacher {
          id
          prefix {
            nameLocal
          }
          firstNameLocal
          lastNameLocal
          telephone
          email
          availableTime
          code
          picturePath
        }
      }
      subject {
        id
        code
        nameLocal
      }
      classSection {
        id sectionNo learnSpanNo
      }
    }
  }
`;

export const ADD_STUDENTENROLLDETAIL = gql`
  mutation addStudentEnrollDetail(
    $courseOutlineRegistrationInput: [StudentEnrollDetailInput!]
  ) {
    addStudentEnrollDetail (
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    )
    {
      id
      academicPeriod{
        id periodCode year semester
      }
      periodCode
      courseOutline{
        id
      }
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      subjectName
      teacher{
        id code firstNameLocal lastNameLocal
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
      }
      teacherCode
      classSections{
        id
      }
    }
  }
`;

export const UPDATE_STUDENTENROLLDETAIL = gql`
  mutation updateStudentEnrollDetail(
    $id: ID!,
    $courseOutlineRegistrationInput: StudentEnrollDetailInput!
  ) {
    addStudentEnrollDetail (
      id: $id
      courseOutlineRegistrationInput: $courseOutlineRegistrationInput
    ) {
      id
    }
  }
`;

export const DELETE_STUDENTENROLLDETAIL = gql`
  mutation deleteStudentEnrollDetail(
    $id: ID!
  ) {
    deleteStudentEnrollDetail (
      id: $id
    ) {
      id
    }
  }
`;

export const UPLOAD_STUDENTENROLLDETAIL_SPREADSHEET = gql`
  mutation uploadStudentEnrollDetailSpreadsheet(
    $file: Upload!
  ) {
    uploadStudentEnrollDetailSpreadsheet (
      file: $file
    ) {
      filename
    }
  }
`;
